import { useContext, useEffect, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenTitle } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2, LoanConfirmation, TxPinVerification } from "src/component"
import utility, { moneyFormat } from "src/utils/utility"
import { FiChevronDown } from "react-icons/fi"
import { FaRegMoneyBillAlt } from "react-icons/fa"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Design } from "src/model"

export const NewLoan: React.FC<any> = ({close, view, setView}:{close:()=>void, view:View, setView:(view:View)=>void}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {notifier} = useContext(VisibilityContext)
    const {user} = useContext(UserContext)
    const [secView, setSecView] = useState<View>('')
    const [input, setInput] = useState<Input>({productCode: '', amount: '', networkProvider: '', pin:''})
    const [loanProducts, setLoanProducts] = useState<any[]>([])
    const [creditAssessment, setCreditAssessment] = useState<CreditAssessment | undefined>(undefined)

    const accountNumber = user?.accountInfo?.[0]?.accountNumber

    async function handleGetLoanProducts() {
        const products = await API.getLoanProducts()
        if(products)setLoanProducts(products)
    }

    useEffect(()=>{
        handleGetLoanProducts()
    },[])

    const handleInput = async(e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>, b?: 'network_provider' | 'product_code' | 'amount') => {
   
        if (e.target.name === 'amount') {
            let val = e.target.value.replace(/,/g, '')
            if (!isNaN(Number(val))) {
                if(Number(val) > creditAssessment?.approvedLoanAmount!){
                    return
                }
                setInput({...input, [e.target.name]: val})
            }
        }

        else setInput({...input, [e.target.name]: e.target.value})
        if (b === 'network_provider' && !creditAssessment){
            const response = await API.runCreditAssessment({
                networkProvider: e.target.value,
                productCode: input.productCode,
            })
            if (response){
            setCreditAssessment(response)
            }else{
                setView('reviewing_eligibility')
            }
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setSecView('loan-confirmation')
    }

    async function handleSubmit() {
       const response = await API.createConsent({
            accountNumber,
            pin: input.pin,
            amount: input.amount,
            loanReference: creditAssessment?.loanReference,
        })
        console.log('response', response)
        notifier.show('Request Submitted', null, 'success')
        setSecView('')
        close()
    }

    const Container =({children}:{children: React.ReactNode}) => {
        switch(true){
            case institutionData.design === Design.DESIGN_2:
                return  (
                    <AppCenterPopupD2  zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD2 title='Apply For Loan' close={close} />
                    {children}
                    </AppCenterPopupD2>)
            default:
                return( 
                    <SidePopupLayout close={close}>
                        <ScreenTitle textSize="2.2" fontWeight="700">Apply For Loan</ScreenTitle>
                        {children}
                    </SidePopupLayout>)
        }
    }

    return (
        <>
            { view === 'new-loan' &&
                <Container>
                    <>
                    <CustomContainer topMargin='2.5'>
                        <Form topMargin="2" onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Loan Product</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='productCode'
                                        value={input.productCode}
                                        style={{color: input.productCode ? '#000000' : '#667085'}}
                                        onChange={(e) => handleInput(e,'product_code')}
                                        //required
                                    >
                                        <option value="">Select Loan Product</option>
                                        {loanProducts?.map((product: any) => (
                                            <option key={product.productCode} value={product.productCode}>{product.name}</option>
                                        ))}
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                          {input.productCode &&<FormGroupWithIcon>
                                <label>Select Phone Number Telco</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='networkProvider'
                                        value={input.networkProvider}
                                        style={{color: input.networkProvider ? '#000000' : '#667085'}}

                                        onChange={(e)=>handleInput(e,'network_provider')}
                                        //required
                                    >
                                        <option value="">Select Telco</option>
                                        <option value="MTN">MTN</option>
                                        <option value="GLO">Glo</option>
                                        <option value="Airtel">Airtel</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>}
                            {creditAssessment && <>
                            <GridContainer
                            bgColor="#E7F6F5" minHeight="6.2" padding="1"
                            leftPadding="2" rightPadding="2" radius="0.8"
                        >
                            <FlexRow>
                                <FaRegMoneyBillAlt style={{color: '#0D968F', fontSize: '2rem'}} />
                                <AppText textSize="1.2" color="#0A756F" leftMargin="1">
                                    Maximum Loan Amount: <AppSpan textSize="1.2" color="#0A756F" fontWeight="600">{moneyFormat(creditAssessment.approvedLoanAmount, true,institutionData?.defaultCurrency)}</AppSpan>
                                </AppText>
                            </FlexRow>
                            </GridContainer>
                            <AppText topMargin="2" bottomMargin="2">
                            Enter the amount you'd like to borrow within your maximum eligible limit.
                            </AppText>
                                <FormGroup>
                                <label>Amount</label>
                                <input 
                                    name='amount'
                                    value={input.amount ? utility.moneyFormat(input.amount,institutionData?.defaultCurrency) : ''}
                                    onChange={(e) => handleInput(e,'amount')}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        
                            <FlexRow justifyContent='flex-end' gap="1.5" topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                            </>}
                        </Form>
                    </CustomContainer>
                    </>
                </Container>
            }
            { secView === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
            }
            { secView === 'loan-confirmation' &&
                <LoanConfirmation
                    close={close}
                    next={() => setSecView('pin')} 
                    back={() => {
                        setSecView('')
                        setView('new-loan')
                    }}
                    creditAssessment={creditAssessment}
                    networkProvider={input.networkProvider}
                />
            }
        </>
    )
}

type View = 'new-overdraft' | 'new-loan' | 'loan-details' | 'terms_conditions' | 'reviewing_eligibility' | 'loan-confirmation' | 'pin' | ''

type Input = {
    productCode: string
    networkProvider: 'MTN' | 'Airtel' | 'Glo' | ''
    amount: string
    pin: string
}

type CreditAssessment = {
    approvedLoanAmount: number
    interestRate: number
    loanOffer: string
    loanReference: string
    loanTenure: number
}